import { useEffect, useState } from 'react';
import { onAuthStateChanged } from 'firebase/auth';
import { auth } from '../firebaseAuth';

/** Unmount private report state when Firebase signs out, even before parent props update. */
export const useM2MIdentity = (userId: string): boolean => {
  const [uid, setUid] = useState(() => auth.currentUser?.uid);
  useEffect(() => onAuthStateChanged(auth, user => setUid(user?.uid)), []);
  return Boolean(userId && uid === userId && auth.currentUser?.uid === userId);
};
